import { Select, SelectProps } from 'antd';

const SelectYesNo = ({ ...props }: SelectProps) => {
  const yesNoOptions = [
    {
      value: 'true',
      label: 'Sim',
    },
    {
      value: 'false',
      label: 'Não',
    },
  ];

  return (
    <Select
      {...props}
      allowClear
      style={{ width: '100' }}
      options={yesNoOptions}
    />
  );
};

export default SelectYesNo;
